/*
  ML008 - mobile collection card revamp (A/B variation).

  Three behaviours, all fully delegated on `document` so cards injected by the AJAX
  pagination / facet section replacement work without any re-initialisation:

    1. the pagination dots follow the gallery scroll position;
    2. a horizontal drag on a card never navigates to the product (swipe vs tap);
    3. hovering a colour swatch swaps the primary image (desktop).

  (3) is a copy of the inline script in snippets/product-card.liquid and shares its
  `window.__mlColorVariantHover` guard: whichever card renders first wins, and the ML008
  templates never render the regular card, so without this the swap would be missing there.
*/

(function () {
  if (window.__ml008CollectionCard) {
    return;
  }

  window.__ml008CollectionCard = true;

  var pendingGallery = null;

  function updateDots(gallery) {
    var media = gallery.parentElement;
    var dots = media ? media.querySelector('.ml008-dots') : null;

    if (!dots || !gallery.clientWidth) {
      return;
    }

    var index = Math.round(gallery.scrollLeft / gallery.clientWidth);

    for (var i = 0; i < dots.children.length; i++) {
      dots.children[i].classList.toggle('is-active', i === index);
    }
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var gallery = event.target;

      if (!gallery || !gallery.classList || !gallery.classList.contains('ml008-gallery')) {
        return;
      }

      if (pendingGallery) {
        pendingGallery = gallery;
        return;
      }

      pendingGallery = gallery;

      requestAnimationFrame(function () {
        var target = pendingGallery;
        pendingGallery = null;
        updateDots(target);
      });
    },
    { capture: true, passive: true }
  );

  var startX = 0;
  var startY = 0;
  var dragged = false;

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (!event.target.closest || !event.target.closest('.product-card--ml008')) {
        return;
      }

      startX = event.clientX;
      startY = event.clientY;
      dragged = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (dragged) {
        return;
      }

      var deltaX = Math.abs(event.clientX - startX);
      var deltaY = Math.abs(event.clientY - startY);

      if (deltaX > 8 && deltaX > deltaY) {
        dragged = true;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!dragged || !event.target.closest || !event.target.closest('.product-card--ml008')) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    },
    true
  );

  if (window.__mlColorVariantHover) {
    return;
  }

  window.__mlColorVariantHover = true;

  function primaryImage(el) {
    var card = el.closest('product-card');
    return card ? card.querySelector('.product-card__image--primary') : null;
  }

  document.addEventListener('mouseover', function (event) {
    var dot = event.target.closest('.product-card__color-variant-item[data-sibling-image]');
    if (!dot) return;
    var img = primaryImage(dot);
    if (!img) return;

    if (typeof img.dataset.mlOriginalSrc === 'undefined') {
      img.dataset.mlOriginalSrc = img.getAttribute('src') || '';
      img.dataset.mlOriginalSrcset = img.getAttribute('srcset') || '';
    }

    img.removeAttribute('srcset');
    img.src = dot.getAttribute('data-sibling-image');
  });

  document.addEventListener('mouseout', function (event) {
    var dot = event.target.closest('.product-card__color-variant-item[data-sibling-image]');
    if (!dot) return;
    if (dot.contains(event.relatedTarget)) return;

    var img = primaryImage(dot);
    if (!img || typeof img.dataset.mlOriginalSrc === 'undefined') return;

    if (img.dataset.mlOriginalSrcset) {
      img.setAttribute('srcset', img.dataset.mlOriginalSrcset);
    }
    img.src = img.dataset.mlOriginalSrc;
  });
})();
